import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Table } from "react-bootstrap";
import NumberFormat from "react-number-format";

import FormBox from "../../../components/FormBox/FormBox";
import { LoadingButton } from "../../../Utils/CustomComponent";
import PopupWrapper from "../../../components/PopupWrapper";
import ErrorBoundary from "../../../components/ErrorBoundary";
import { IneterestCalculatorSchema } from "../../../Utils/formOptions";

ChartJS.register(ArcElement, Tooltip, Legend);

const InterestCalculator = ({ show, setShow }) => {
  const [finalData, setFinalData] = useState({
    Interest: 0,
    "Principal Amount": 0,
    "Total Value": 0,
  });
  const [disableBtn, setDisableBtn] = useState(false);
  const {
    handleSubmit,
    register,
    watch,
    setValue,
    formState: { errors },
    resetField,
  } = useForm(IneterestCalculatorSchema);

  const dueMonth = watch("dueMonth");

  function onSubmit(data) {
    const {
      balance,
      startDate,
      termYears,
      annualRatePercent,
      yearBasis,
      dayCountBasis,
    } = data;

    const rate = annualRatePercent / 100;
    const dailyRate = rate / yearBasis;

    const start = new Date(startDate);
    const end = new Date(start);
    end.setFullYear(start.getFullYear() + termYears);

    let daysBetween;
    if (dayCountBasis === "30day") {
      // 30-day month × 12 months/year × termYears
      daysBetween = 360 * termYears;
    } else {
      // Actual day difference
      const diffMs = end - start;
      daysBetween = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
    }

    const interest = balance * dailyRate * daysBetween;

    const updatedData = {
      Interest: interest,
      "Principal Amount": balance,
      "Total Value": parseFloat(interest + balance),
    };
    setFinalData(updatedData);
  }

  return (
    <div>
      <PopupWrapper
        // extraClass="width-800"
        Component={
          <ErrorBoundary>
            <div className="row">
              <div className="col-6">
                <FormBox
                  options={calcArr(dueMonth)}
                  register={register}
                  watch={watch}
                  setValue={setValue}
                  errors={errors}
                />

                <div>
                  <LoadingButton
                    type="button"
                    className="btn btn-primary mt-3 text-white"
                    onClick={handleSubmit(onSubmit)}
                    title={"Calculate Interest"}
                    disabled={disableBtn}
                    loading={disableBtn}
                  />
                </div>
              </div>
              <div className="col-6">
                <HalfDoughnut finalData={finalData} />
              </div>
            </div>
          </ErrorBoundary>
        }
        title="Loan Interest Calculator"
        titleClassName="p-3"
        toShow={show}
        closeEventHandler={() => {
          setShow(false);
          setFinalData({
            Interest: 0,
            "Principal Amount": 0,
            "Total Value": 0,
          });
          resetField("balance");
          resetField("annualRatePercent");
          resetField("termYears");
          resetField("startDate");
          resetField("yearBasis");
          resetField("dayCalcBasis");
        }}
      />
    </div>
  );
};

export default InterestCalculator;

const calcArr = (dueMonth) => {
  return [
    {
      title: "Balance",
      field: "balance",
      type: "number",
      className: "col-12",
    },
    {
      title: "Start Date",
      field: "startDate",
      type: "date",
      className: "col-12",
    },
    // {
    //   title: "Due Month",
    //   field: "dueMonth",
    //   type: "select",
    //   options: [
    //     { label: "January", value: 1 },
    //     { label: "February", value: 2 },
    //     { label: "March", value: 3 },
    //     { label: "April", value: 4 },
    //     { label: "May", value: 5 },
    //     { label: "June", value: 6 },
    //     { label: "July", value: 7 },
    //     { label: "August", value: 8 },
    //     { label: "September", value: 9 },
    //     { label: "October", value: 10 },
    //     { label: "November", value: 11 },
    //     { label: "December", value: 12 },
    //   ],
    //   className: "col-6",
    //   defaultValue: 1,
    // },

    // {
    //   title: "Due Day",
    //   field: "dueDay",
    //   type: "select",
    //   options: [1, 3, 5, 7, 8, 10, 12].includes(dueMonth)
    //     ? Array.from({ length: 31 }, (_, i) => ({
    //         label: `${i + 1}`,
    //         value: `${i + 1}`,
    //       }))
    //     : [4, 6, 9, 11].includes(dueMonth)
    //     ? Array.from({ length: 30 }, (_, i) => ({
    //         label: `${i + 1}`,
    //         value: `${i + 1}`,
    //       }))
    //     : dueMonth == 2
    //     ? Array.from({ length: 28 }, (_, i) => ({
    //         label: `${i + 1}`,
    //         value: `${i + 1}`,
    //       }))
    //     : [],
    //   className: "col-6",
    //   defaultValue: "1",
    // },

    // {
    //   title: "Period Unit",
    //   field: "periodUnit",
    //   type: "select",
    //   options: [
    //     { label: "Days", value: "Days" },
    //     { label: "Weeks", value: "Weeks" },
    //     { label: "Months", value: "Months" },
    //     { label: "Quarters", value: "Quarters" },
    //     { label: "Years", value: "Years" },
    //   ],
    //   defaultValue: "Years",
    //   className: "col-12",
    // },
    {
      title: "Term in Years",
      field: "termYears",
      type: "number",
      className: "col-6",
    },
    {
      title: "Annual Rate",
      field: "annualRatePercent",
      type: "number",
      className: "col-6",
    },
    {
      title: "Calculate Daily Rate Using",
      field: "yearBasis",
      type: "radio",
      options: [
        {
          title: "360 Days Year Basis",
          value: "360",
        },
        {
          title: "365 Days Year Basis",
          value: "365",
        },
      ],
      className: "col-6",
    },
    {
      title: "Calculate Days Between Dates Using",
      field: "dayCountBasis",
      type: "radio",
      options: [
        {
          title: "30-Day Month Basis",
          value: "30day",
        },
        {
          title: "Actual Number of Days",
          value: "actual",
        },
      ],
      className: "col-6",
    },
  ];
};

const HalfDoughnut = ({ finalData }) => {
  const data = {
    labels: ["Principal", "Interest"],
    datasets: [
      {
        data: [finalData["Principal Amount"], finalData["Interest"]],
        backgroundColor: ["#4CAF50", "#e0e0e0"],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    rotation: -90,
    circumference: 180,
    cutout: "70%",
    layout: {
      padding: {
        top: 0,
        bottom: 0,
      },
    },
    plugins: {
      legend: {
        display: true,
        position: "bottom",
        labels: {
          padding: 10, // reduce this to shrink space
          boxWidth: 20,
        },
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem) => {
            const value = tooltipItem.raw;
            return `${tooltipItem.label} Amount: $${value.toLocaleString()}`; // Change ₹ to your currency symbol
          },
        },
      },
    },
  };

  return (
    <div>
      <div style={{ width: "50%", margin: "auto", height: "30vh" }}>
        <Doughnut data={data} options={options} />
      </div>
      <Table bordered size="lg" className="mt-5" style={{ fontSize: "16px" }}>
        <tbody>
          {Object.keys(finalData).map((el) => (
            <tr key={el}>
              <th style={{ background: "rgb(251, 251, 251)" }}>{el}</th>
              <td>
                {" "}
                <NumberFormat
                  displayType="text"
                  value={finalData[el]}
                  prefix={"$"}
                  fixedDecimalScale={true}
                  decimalScale={2}
                  thousandSeparator={true}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

// function convertToYears(duration, unit) {
//   switch (duration.toLowerCase()) {
//     case "days":
//       return unit / 365;
//     case "weeks":
//       return unit / 52;
//     case "months":
//       return unit / 12;
//     case "quarters":
//     case "quaters": // handles typo in UI
//       return unit / 4;
//     case "years":
//     default:
//       return unit;
//   }
// }

// function calculateSimpleInterest(principal, annualRate, duration, unit) {
//   const timeInYears = convertToYears(duration, unit);
//   const interest = (principal * annualRate * timeInYears) / 100;
//   return interest;
// }
